import React from "react";

export const FeedbackDetailContext = React.createContext(null);

export const useFeedbackDetailContext = () => {
  const context = React.useContext(FeedbackDetailContext);

  if (!context) throw new Error("Feedback Detail Context not provided!");

  return context;
};
